<template>
    <v-row justify="center" class="subtitle-2 mb-8">
        <v-col v-for="({ icon, data }, i) in items" :key="i" cols="auto" class="pa-4">
            <v-row align="center">
                <v-col v-if="icon" cols="auto">
                    <v-icon>{{ icon }}</v-icon>
                </v-col>
                <v-col cols="auto" class="pa-4">
                    <v-row justify="space-between" v-for="({ text, value }, j) in data" :key="j">
                        <v-col class="py-0" cols="auto">{{ text }}</v-col>
                        <v-col class="py-0" cols="auto">{{ value }}</v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: { total: { type: Object } },
    computed: {
        items() {
            const { sale, delivery, pCom, dCom, manual, sum } = this.total;

            return [
                {
                    icon: null,
                    data: [
                        { text: "총 판매금액", value: sale.format() + " 원" },
                        { text: "총 배송비(도서산간 포함)", value: delivery.format() + " 원" },
                        { text: "결제금액 소계", value: (sale + delivery).format() + " 원" },
                    ],
                },
                {
                    icon: "mdi-minus-circle",
                    data: [
                        { text: "총 PG사수수료", value: pCom.format() + " 원" },
                        { text: "총 플랫폼수수료", value: dCom.format() + " 원" },
                        { text: "수수료 소계", value: (pCom + dCom).format() + " 원" },
                    ],
                },
                {
                    icon: "mdi-pause-circle mdi-rotate-90",
                    data: [
                        { text: "자동처리금액", value: (sale + delivery - pCom - dCom).format() + " 원" },
                        { text: "수동처리금액", value: (manual >= 0 ? "+" : "") + manual.format() + " 원" },
                        { text: "정산예상금액", value: "= " + sum.format() + " 원" },
                    ],
                },
            ];
        },
    },
};
</script>

<style></style>
